import React, {useEffect, useLayoutEffect, useMemo, useRef, useState} from 'react'
import useQueryLeagueList from '../../../../hooks/api/league/useQueryLeagueList'
import TableHeader from '../../../../components/table/TableHeader'
import Text from '../../../../components/text/Text'
import TableLayout from '../../../../components/table/TableLayout'
import TableItem from '../../../../components/table/TableItem'
import {ILeagueList} from '../../../../apis/league/getLeagueList'
import WizButton from '../../../../components/button/WizButton'
import WizImage from '../../../../components/image/WizImage'
import useNavigation from '../../../../hooks/useNavigation'
import {useTime} from '../../../../utils/time'
import AddEventModal from './AddEventModal'
import DeleteLeagueModal from './DeleteLeagueModal'
import {useQueryGetShowLeagues} from '../../../../hooks/api/league/useQueryGetShowLeagueSidebar'
import Span from '../../../../components/text/Span'
import WizPagination from '../../../../components/pagination/WizPagination'

interface IProps {
    className?: string
}

const LeagueContainer: React.FC<IProps> = ({className}) => {
    const {goLeagueDetail, goLeagueCreate} = useNavigation()
    const {localTimeString} = useTime()

    const [currentPage, setCurrentPage] = useState(1)
    const [onGoingCount, setOnGoingCount] = useState(0)
    const [previousCount, setPreviousCount] = useState(0)
    const [leagueState, setLeagueState] = useState('ongoing')

    const {data, pageInfo, refetch} = useQueryLeagueList(currentPage)
    const {data: leagues} = useQueryGetShowLeagues()

    const leagueList = useMemo(() => {
        const list: ILeagueList[] = []
        const renderList = data?.filter(item => !item?.show)
        renderList?.map(item => list?.push(item))
        return list
    }, [data])

    const showLeagues = useMemo(() => {
        return leagues?.leagues?.sort((a, b) => b?.show - a?.show)
    }, [leagues])

    const addEventModalRef = useRef<any>()
    const deleteLeagueModalRef = useRef<any>()

    useEffect(() => {
        refetch()
    }, [currentPage])

    const onClickAddEvent = (e, league) => {
        e.stopPropagation()
        addEventModalRef?.current?.show(league)
    }

    const onClickDeleteLeague = (e, id) => {
        e.stopPropagation()
        deleteLeagueModalRef?.current?.show(id)
    }

    useLayoutEffect(() => {
        setOnGoingCount(leagues?.count)
    }, [showLeagues])

    return (
        <div className={className}>
            <div>
                <WizButton onClick={() => goLeagueCreate()} text={'Create League'} size={'medium'} type={'primary'} />
            </div>
            <div className={'mt-[30px]'}>
                <Text className={'text-h4 py-[10px]'}>Ongoing Leagues ({onGoingCount})</Text>
                <TableHeader
                    className={
                        'grid-cols-[auto_450px_150px_250px] lg:grid-cols-[1fr_380px_60px_210px] md:hidden lg:gap-x-[10px]'
                    }>
                    <Text>Name</Text>
                    <Text>Date</Text>
                    <Text className={'lg:text-center'}>Order(Rank)</Text>
                    <Text className={'md:text-center'}>Action</Text>
                </TableHeader>
                <TableLayout>
                    {showLeagues?.map(league => (
                        <>
                            <TableItem
                                onClick={() => goLeagueDetail(league?.id)}
                                key={league?.id}
                                className={
                                    'grid-cols-[auto_450px_150px_250px] lg:grid-cols-[1fr_380px_60px_210px] md:block lg:gap-x-[10px] sm:px-[22px]'
                                }>
                                <div className={'flex items-center space-x-[10px] truncate md:justify-center'}>
                                    <WizImage src={league?.icon} className={'w-[30px]'} />
                                    <div className={'truncate'}>
                                        <Text className={'text-ti2 truncate'}>{league?.names.ko}</Text>
                                        <Text className={'text-body3 text-font03 truncate'}>({league?.names.en})</Text>
                                    </div>
                                </div>
                                <Text className={'text-font02 md:text-body3 md:mt-[10px] md:text-center'}>
                                    {localTimeString(league?.start_at)} ~ {localTimeString(league?.end_at)}
                                </Text>
                                <Text className={'lg:text-center md:mt-[10px]'}>
                                    <Span className={'hidden md:inline text-ti2 text-font02'}>Order : </Span>
                                    {league?.show} ({league?.rank})
                                </Text>
                                <div className={'space-x-[10px]  md:text-center md:mt-[10px]'}>
                                    <WizButton
                                        size={'small'}
                                        type={'blue'}
                                        text={'Add Event'}
                                        onClick={e => onClickAddEvent(e, league)}
                                    />
                                    <WizButton
                                        size={'small'}
                                        type={'red'}
                                        text={'Delete'}
                                        onClick={e => onClickDeleteLeague(e, league?.id)}
                                    />
                                </div>
                            </TableItem>
                        </>
                    ))}
                </TableLayout>
            </div>

            <div className={'mt-[120px]'}>
                <Text className={'text-h4 py-[10px]'}>Not Ongoing Leagues</Text>
                <TableHeader className={'grid-cols-[1fr_380px_210px] md:hidden lg:gap-x-[10px]'}>
                    <Text>Name</Text>
                    <Text>Date</Text>
                    <Text className={'md:text-center'}>Action</Text>
                </TableHeader>
                <TableLayout>
                    {leagueList?.map(league => (
                        <>
                            <TableItem
                                onClick={() => goLeagueDetail(league?.id)}
                                key={league?.id}
                                className={'grid-cols-[1fr_380px_210px] md:block lg:gap-x-[10px] sm:px-[22px]'}>
                                <div className={'flex items-center space-x-[10px] truncate md:justify-center'}>
                                    <WizImage src={league?.icon} className={'w-[30px]'} />
                                    <div className={'truncate'}>
                                        <Text className={'text-ti2 truncate'}>{league?.names.ko}</Text>
                                        <Text className={'text-body3 text-font03 truncate'}>({league?.names.en})</Text>
                                    </div>
                                </div>
                                <Text className={'text-font02 md:text-body3 md:mt-[10px] md:text-center'}>
                                    {localTimeString(league?.start_at)} ~ {localTimeString(league?.end_at)}
                                </Text>
                                <div className={'space-x-[10px] md:text-center md:mt-[10px]'}>
                                    <WizButton
                                        size={'small'}
                                        type={'blue'}
                                        text={'Add Event'}
                                        onClick={e => onClickAddEvent(e, league)}
                                    />
                                    <WizButton
                                        size={'small'}
                                        type={'red'}
                                        text={'Delete'}
                                        onClick={e => onClickDeleteLeague(e, league?.id)}
                                    />
                                </div>
                            </TableItem>
                        </>
                    ))}
                </TableLayout>
                <WizPagination
                    totalPage={pageInfo?.total_count}
                    currentPage={currentPage}
                    onPageChange={item => setCurrentPage(item)}
                    isScrollTop={false}
                />
            </div>
            <DeleteLeagueModal ref={deleteLeagueModalRef} />
            <AddEventModal ref={addEventModalRef} />
        </div>
    )
}

export default LeagueContainer
